import { useTheme } from "../hooks/useTheme";

export default function Logo() {

    const { theme } = useTheme();

    return (
        <img src={theme.logo.path} height={theme.logo.height} alt="Logo"/>
    );
}